import React, {Component} from 'react'

class File extends Component {

    constructor(props) {
        super(props)
        this.state = {
            label: '',
            error: '',
            multiple: props.params.hasOwnProperty('multiple') ? props.params.multiple : false
        }
    }

    onChange = (e) => {
        if (this.state.multiple) {
            if (e.target.files.length) {
                this.setState({error: ''})
                this.props.setField(this.props.params.name, e.target.files)
            }
        } else {
            if (e.target.files[0]) {
                this.setState({error: ''})
                this.props.setField(this.props.params.name, e.target.files[0])
            }
        }
    }

    render() {
        if (this.props.state.fields[this.props.params.name].error) {
            this.state.error = <span className="error"><i className="fa fa-warning"></i> {this.props.state.fields[this.props.params.name].error}</span>
        } else {
            this.state.error = <span className="error"></span>
        }

        if (this.props.state.fields[this.props.params.name].value) {
            this.state.label = 'active'
        }

        let hasError = typeof this.state.error.props.children !== 'undefined' ? 'has-error' : ''
        return (
            <div className={'field field-text ' + this.props.params.id + ' ' + hasError} style={this.props.params.style}>
                <div>
                    {this.props.params.label
                        ? <label htmlFor={this.props.params.id} className={this.props.params.classLabel}>
                            {this.props.params.label}
                        </label>
                        : null
                    }
                    <input
                        type="file"
                        spellCheck="false"
                        autoComplete="off"
                        id={this.props.params.id}
                        className={this.props.params.classInput}
                        name={this.props.params.name}
                        onChange={(e) => this.onChange(e)}
                        disabled={this.props.params.disabled}
                        multiple={this.state.multiple}
                    />
                    <p className='help-block help-block-error'>{this.state.error}</p>
                </div>
            </div>
        )
    }
}

export default File


// WEBPACK FOOTER //
// ./src/components/common/Field/File.js